import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import MainLayout from "../components/layout/MainLayout";
import Breadcrumbs from "../components/common/Breadcrumbs";
import SafetyPlanList from "./Residential/Optional/SafetyPlan/SafetyPlanList";
import {
    fetchSafetyPlans,
    deleteSafetyPlan,
    setCurrentSafetyPlan,
    clearCurrentSafetyPlan,
} from "../store/slices/safetyPlansSlice";

const SafetyPlans = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { safetyPlans, isLoading, error } = useSelector((state) => state.safetyPlans);

    useEffect(() => {
        dispatch(fetchSafetyPlans());
    }, [dispatch]);

    const handleAdd = () => {
        dispatch(clearCurrentSafetyPlan());
        navigate("/residential/optional/safety-plan/add");
    };

    const handleEdit = (id) => {
        const plan = safetyPlans.find((p) => p.id === id);
        dispatch(setCurrentSafetyPlan(plan));
        navigate(`/residential/optional/safety-plan/edit/${id}`);
    };

    const handleDelete = async (id) => {
        await dispatch(deleteSafetyPlan(id));
    };

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Breadcrumbs />
                <div className="card">
                    <div className="card-body p-0">
                        <SafetyPlanList
                            records={safetyPlans}
                            loading={isLoading}
                            onAdd={handleAdd}
                            onEdit={handleEdit}
                            onDelete={handleDelete}
                        />
                    </div>
                </div>
                {error && <div className="text-danger mt-2">{error}</div>}
            </div>
        </MainLayout>
    );
};

export default SafetyPlans;
